<template>
  <div class="p-6">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold">Rapor Kategorileri</h1>
      <button
        @click="openCreateModal"
        class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
        Yeni Kategori
      </button>
    </div>

    <!-- Kategoriler Tablosu -->
    <div class="bg-white rounded-lg shadow overflow-hidden">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-16">Sira</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kategori Adi</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-24">Icon</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-24">Durum</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-24">Rapor Sayisi</th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider w-32">Islemler</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="(category, index) in categories" :key="category.id" class="hover:bg-gray-50">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              <div class="flex items-center gap-2">
                <button
                  @click="moveUp(index)"
                  :disabled="index === 0"
                  class="p-1 hover:bg-gray-200 rounded disabled:opacity-30"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="18 15 12 9 6 15"></polyline>
                  </svg>
                </button>
                <button
                  @click="moveDown(index)"
                  :disabled="index === categories.length - 1"
                  class="p-1 hover:bg-gray-200 rounded disabled:opacity-30"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </button>
                {{ category.sort_order }}
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap">
              <span class="text-sm font-medium text-gray-900">{{ category.name }}</span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              <span class="inline-flex items-center px-2 py-1 rounded bg-gray-100">
                {{ category.icon || 'file-text' }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap">
              <span
                :class="category.status == 1 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
                class="px-2 py-1 text-xs font-medium rounded-full"
              >
                {{ category.status == 1 ? 'Aktif' : 'Pasif' }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
              {{ category.report_count || 0 }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
              <button
                @click="openEditModal(category)"
                class="text-blue-600 hover:text-blue-900 mr-3"
              >
                Duzenle
              </button>
              <button
                @click="deleteCategory(category)"
                class="text-red-600 hover:text-red-900"
              >
                Sil
              </button>
            </td>
          </tr>
          <tr v-if="categories.length === 0">
            <td colspan="6" class="px-6 py-8 text-center text-gray-500">
              Henuz kategori eklenmemis
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Raporlar ve Kategori Atama -->
    <div class="mt-8">
      <h2 class="text-xl font-bold mb-4">Raporlara Kategori Ata</h2>
      <div class="bg-white rounded-lg shadow overflow-hidden">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rapor Adi</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-64">Kategori</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-for="report in reports" :key="report.id" class="hover:bg-gray-50">
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {{ report.name }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <select
                  v-model="report.category_id"
                  @change="assignCategory(report)"
                  class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm"
                >
                  <option :value="null">-- Kategori Sec --</option>
                  <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                    {{ cat.name }}
                  </option>
                </select>
              </td>
            </tr>
            <tr v-if="reports.length === 0">
              <td colspan="2" class="px-6 py-8 text-center text-gray-500">
                Henuz rapor eklenmemis
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        <div class="px-6 py-4 border-b">
          <h3 class="text-lg font-semibold">{{ isEditing ? 'Kategori Duzenle' : 'Yeni Kategori' }}</h3>
        </div>
        <div class="px-6 py-4">
          <div class="space-y-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Kategori Adi *</label>
              <input
                v-model="form.name"
                type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Kategori adi girin"
              />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Icon</label>
              <select
                v-model="form.icon"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="file-text">file-text (Varsayilan)</option>
                <option value="trending-up">trending-up (Grafik)</option>
                <option value="users">users (Kullanicilar)</option>
                <option value="dollar-sign">dollar-sign (Finans)</option>
                <option value="activity">activity (Aktivite)</option>
                <option value="bar-chart-2">bar-chart-2 (Bar Grafik)</option>
                <option value="pie-chart">pie-chart (Pasta Grafik)</option>
                <option value="target">target (Hedef)</option>
                <option value="calendar">calendar (Takvim)</option>
                <option value="briefcase">briefcase (Is)</option>
              </select>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Durum</label>
              <select
                v-model="form.status"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option :value="1">Aktif</option>
                <option :value="0">Pasif</option>
              </select>
            </div>
          </div>
        </div>
        <div class="px-6 py-4 border-t bg-gray-50 flex justify-end gap-3">
          <button
            @click="closeModal"
            class="px-4 py-2 text-gray-700 border border-gray-300 rounded hover:bg-gray-100"
          >
            Iptal
          </button>
          <button
            @click="saveCategory"
            :disabled="saving"
            class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {{ saving ? 'Kaydediliyor...' : 'Kaydet' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/services/http";

export default {
  name: "AdminReportCategories",
  data() {
    return {
      categories: [],
      reports: [],
      showModal: false,
      isEditing: false,
      editingId: null,
      saving: false,
      form: {
        name: "",
        icon: "file-text",
        status: 1
      }
    };
  },
  mounted() {
    this.loadCategories();
    this.loadReports();
  },
  methods: {
    async loadCategories() {
      try {
        const response = await http.reportCategories.getAll(true);
        if (response.data.success) {
          this.categories = response.data.categories;
          // Rapor sayısını hesapla
          this.calculateReportCounts();
        }
      } catch (error) {
        console.error("Kategoriler yuklenemedi:", error);
      }
    },
    async loadReports() {
      try {
        const response = await http.getVisibleReports();
        if (response.data.success) {
          this.reports = response.data.results || [];
        }
      } catch (error) {
        console.error("Raporlar yuklenemedi:", error);
      }
    },
    calculateReportCounts() {
      const counts = {};
      this.reports.forEach(report => {
        if (report.category_id) {
          counts[report.category_id] = (counts[report.category_id] || 0) + 1;
        }
      });
      this.categories = this.categories.map(cat => ({
        ...cat,
        report_count: counts[cat.id] || 0
      }));
    },
    openCreateModal() {
      this.isEditing = false;
      this.editingId = null;
      this.form = {
        name: "",
        icon: "file-text",
        status: 1
      };
      this.showModal = true;
    },
    openEditModal(category) {
      this.isEditing = true;
      this.editingId = category.id;
      this.form = {
        name: category.name,
        icon: category.icon || "file-text",
        status: parseInt(category.status)
      };
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    async saveCategory() {
      if (!this.form.name.trim()) {
        alert("Kategori adi zorunludur");
        return;
      }

      this.saving = true;
      try {
        let response;
        if (this.isEditing) {
          response = await http.reportCategories.update(this.editingId, this.form);
        } else {
          response = await http.reportCategories.store(this.form);
        }

        if (response.data.success) {
          this.closeModal();
          this.loadCategories();
        } else {
          alert(response.data.message || "Islem basarisiz");
        }
      } catch (error) {
        console.error("Kaydetme hatasi:", error);
        alert("Bir hata olustu");
      } finally {
        this.saving = false;
      }
    },
    async deleteCategory(category) {
      if (!confirm(`"${category.name}" kategorisini silmek istediginize emin misiniz?`)) {
        return;
      }

      try {
        const response = await http.reportCategories.delete(category.id);
        if (response.data.success) {
          this.loadCategories();
        } else {
          alert(response.data.message || "Silme basarisiz");
        }
      } catch (error) {
        console.error("Silme hatasi:", error);
        alert("Bir hata olustu");
      }
    },
    async moveUp(index) {
      if (index === 0) return;
      this.swapOrder(index, index - 1);
    },
    async moveDown(index) {
      if (index === this.categories.length - 1) return;
      this.swapOrder(index, index + 1);
    },
    async swapOrder(fromIndex, toIndex) {
      const categories = [...this.categories];
      const temp = categories[fromIndex].sort_order;
      categories[fromIndex].sort_order = categories[toIndex].sort_order;
      categories[toIndex].sort_order = temp;

      // Array'i swap et
      [categories[fromIndex], categories[toIndex]] = [categories[toIndex], categories[fromIndex]];
      this.categories = categories;

      // Backend'e gonder
      const orders = this.categories.map((cat, idx) => ({
        id: cat.id,
        sort_order: idx + 1
      }));

      try {
        await http.reportCategories.updateOrder(orders);
      } catch (error) {
        console.error("Siralama hatasi:", error);
        this.loadCategories(); // Hata durumunda yeniden yukle
      }
    },
    async assignCategory(report) {
      try {
        const response = await http.reportCategories.assignReportCategory(
          report.id,
          report.category_id
        );
        if (response.data.success) {
          this.calculateReportCounts();
        } else {
          alert(response.data.message || "Atama basarisiz");
        }
      } catch (error) {
        console.error("Kategori atama hatasi:", error);
      }
    }
  }
};
</script>
